import React from 'react';
import { observer } from 'mobx-react';
import HeaderAuthComponent from './Header-auth.component';
import useHeaderAuth from './useHeaderAuth';

const Container: React.FC = () => {
    const { lang } = useHeaderAuth();

    return (
        <>
            <HeaderAuthComponent lang={lang.lang} />
        </>
    );
};

const HeaderAuthContainer = observer(Container);

export default HeaderAuthContainer;
